(function ($) {

    var methods = {
        init : function() {
            return this.each(function() {

                // For each set of tabs, we want to keep track of
                // which tab is active and its associated content
                var $this = $(this),
                window_width = $(window).width();

                $this.trigger("tabs:beforeCreate",$this);

                var $active, 
                    $content, 
                    $links = $this.find('li.tabs-tab a'),
                    $index = 0;

                //Add aria attributes and roles
                $this.attr('role', 'tablist')
                $this.find('li.tabs-tab').attr('role', 'presentation');
                $links.each(function(){
                    var content_id = $(this.hash).attr('id');
                    $(this).attr({
                        'role': 'tab',
                        'aria-controls': content_id
                    });
                    $(this.hash).attr({
                        'role': 'tabpanel'
                    });
                })

                // If the location.hash matches one of the links, use that as the active tab.
                $active = $($links.filter('[href="'+location.hash+'"]'));

                var triggerSelectOnInit = $active.length > 0;

                // If no match is found, use the first link or any with class 'active' as the initial active tab.
                if ($active.length === 0) {
                    $active = $(this).find('li.tabs-tab a.is-active').first();
                }
                if ($active.length === 0) {
                    $active = $(this).find('li.tabs-tab a').first();
                }

                $active.addClass('is-active').attr('aria-selected', 'true');
                $index = $links.index($active);
                if ($index < 0) {
                    $index = 0;
                }

                if ($active[0] !== undefined) {
                    $content = $($active[0].hash);
                }

                // Hide the remaining content
                $links.not($active).each(function () {
                    $(this.hash).hide().prop('hidden', true);
                });


                // Bind the click event handler
                $this.on('click', 'a', function(e) {
                    $this.trigger("tabs:beforeSelect",$(this));
                    if ($(this).parent().hasClass('is-disabled')) {
                        e.preventDefault();
                        return;
                    }

                    // Make the old tab inactive.
                    $active.removeClass('is-active').attr('aria-selected', 'false');
                    if ($content !== undefined) {
                        $content.hide().prop('hidden', true);
                    }

                    // Update the variables with the new link and content
                    $active = $(this);
                    $content = $(this.hash);
                    $links = $this.find('li.tabs-tab a');

                    // Make the tab active.
                    $active.addClass('is-active').attr('aria-selected', 'true');
                    var $prev_index = $index;
                    $index = $links.index($(this));
                    if ($index < 0) {
                        $index = 0;
                    }

                    // Change url to current tab
                    window.location.hash = $active.attr('href');

                    if ($content !== undefined) {
                        $content.show().prop('hidden', false).focus();
                        $content.trigger("tabs:focus",$content);
                    }

                    $this.trigger("tabs:select",[$this,$content]);
                    // Prevent the anchor's default click action
                    e.preventDefault();
                });

                $this.trigger("tabs:created",$this);
                if(triggerSelectOnInit){
                    $this.trigger("tabs:select",[$this,$content]);
                }

            });

        },
        select_tab : function( id ) {
            this.find('a[href="#' + id + '"]').trigger('click');
        }
    };

    $.fn.tabs = function(methodOrOptions) {
        if ( methods[methodOrOptions] ) {
            return methods[ methodOrOptions ].apply( this, Array.prototype.slice.call( arguments, 1 ));
        } else if ( typeof methodOrOptions === 'object' || ! methodOrOptions ) {
            // Default to "init"
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  methodOrOptions + ' does not exist in jQuery.tabs' );
        }
    };

    $(document).ready(function(){
        $('ul.tabs').not(".tabs--decorative").tabs();
    });
}( jQuery ));
